import {
    addOffer,
    deleteOffer,
    getBasicOfferPrefs,
    getLocalizedOfferPrefs,
    getOffer,
    getOffers,
    getOffersStat,
    getPromoAppsStat,
    getRedirectsStat,
    getRetailerCallsStat,
    updateOffer
} from '../helpers/promoService';
import {checkError, closeAlert, receiveErrorAlert} from './commonsActions';
/*
 * action types
 */

export const FETCH_LOCALIZED_OFFER_PREFS_BEGIN   = 'FETCH_LOCALIZED_OFFER_PREFS_BEGIN';
export const FETCH_LOCALIZED_OFFER_PREFS_SUCCESS = 'FETCH_LOCALIZED_OFFER_PREFS_SUCCESS';

export const FETCH_BASIC_OFFER_PREFS_BEGIN   = 'FETCH_BASIC_OFFER_PREFS_BEGIN';
export const FETCH_BASIC_OFFER_PREFS_SUCCESS = 'FETCH_BASIC_OFFER_PREFS_SUCCESS';

export const FETCH_PROMO_APPS_BEGIN   = 'FETCH_PROMO_APPS_BEGIN';
export const FETCH_PROMO_APPS_SUCCESS = 'FETCH_PROMO_APPS_SUCCESS';
export const FETCH_PROMO_APPS_ERROR = 'FETCH_PROMO_APPS_ERROR';
export const GET_FILTERED_PROMO_APPS = 'GET_FILTERED_PROMO_APPS';

export const FETCH_OFFERS_BEGIN   = 'FETCH_OFFERS_BEGIN';
export const FETCH_OFFERS_SUCCESS = 'FETCH_OFFERS_SUCCESS';
export const FETCH_OFFERS_ERROR = 'FETCH_OFFERS_ERROR';

export const FETCH_OFFER_BEGIN   = 'FETCH_OFFER_BEGIN';
export const FETCH_OFFER_SUCCESS = 'FETCH_OFFER_SUCCESS';
export const FETCH_OFFER_ERROR = 'FETCH_OFFER_ERROR';

export const FETCH_PROMO_APPS_STAT_BEGIN   = 'FETCH_PROMO_APPS_STAT_BEGIN';
export const FETCH_PROMO_APPS_STAT_SUCCESS = 'FETCH_PROMO_APPS_STAT_SUCCESS';
export const FETCH_PROMO_APPS_STAT_ERROR = 'FETCH_PROMO_APPS_STAT_ERROR';

export const FETCH_OFFERS_STAT_BEGIN   = 'FETCH_OFFERS_STAT_BEGIN';
export const FETCH_OFFERS_STAT_SUCCESS = 'FETCH_OFFERS_STAT_SUCCESS';
export const FETCH_OFFERS_STAT_ERROR = 'FETCH_OFFERS_STAT_ERROR';

export const FETCH_RETAIL_CALLS_STAT_BEGIN   = 'FETCH_RETAIL_CALLS_STAT_BEGIN';
export const FETCH_RETAIL_CALLS_STAT_SUCCESS = 'FETCH_RETAIL_CALLS_STAT_SUCCESS';
export const FETCH_RETAIL_CALLS_STAT_ERROR = 'FETCH_RETAIL_CALLS_STAT_ERROR';

export const FETCH_REDIRECTS_STAT_BEGIN   = 'FETCH_REDIRECTS_STAT_BEGIN';
export const FETCH_REDIRECTS_STAT_SUCCESS = 'FETCH_REDIRECTS_STAT_SUCCESS';
export const FETCH_REDIRECTS_STAT_ERROR = 'FETCH_REDIRECTS_STAT_ERROR';

/*
 * action creators
 */


export const fetchLocalizedOfferPrefs = query => dispatch => {
    dispatch({
        type: FETCH_LOCALIZED_OFFER_PREFS_BEGIN
    });
    return getLocalizedOfferPrefs(query).then(res => {
        dispatch({
            type: FETCH_LOCALIZED_OFFER_PREFS_SUCCESS,
            payload: {
                prefs: res.data,
            }
        });
        return res
    }, error => {
        dispatch(checkError(error));
        dispatch(receiveErrorAlert('No data')); // error message
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
    })
};

export const fetchBasicOfferPrefs = query => dispatch => {
    dispatch({
        type: FETCH_BASIC_OFFER_PREFS_BEGIN
    });
    return getBasicOfferPrefs(query).then(res => {
        dispatch({
            type: FETCH_BASIC_OFFER_PREFS_SUCCESS,
            payload: {
                prefs: res.data,
            }
        });
        return res
    }, error => {
        dispatch(checkError(error));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
    })
};

export const fetchPromoAppsStatName = query => dispatch => {
    dispatch({
        type: FETCH_PROMO_APPS_STAT_BEGIN
    });
    return getPromoAppsStat(query).then(res => {
        dispatch({
            type: FETCH_PROMO_APPS_STAT_SUCCESS,
            payload: {
                stat: res.data.statistics,
                numberOfElements : res.numberOfElements,
                totalElements: res.totalElements,
                totalPages: res.totalPages
            }
        });
        return res
    }, error => {
        dispatch(checkError(error));
        dispatch(receiveErrorAlert('No data')); // error message
        setTimeout(() => {
            dispatch(closeAlert());
            dispatch({
                type: FETCH_PROMO_APPS_STAT_ERROR
            })
        }, 2000);
    })
};

export const fetchOffersStat = query => dispatch => {
    dispatch({
        type: FETCH_OFFERS_STAT_BEGIN
    });
    return getOffersStat(query).then(res => {
        dispatch({
            type: FETCH_OFFERS_STAT_SUCCESS,
            payload: {
                stat: res.data,
            }
        });
        return res
    }, error => {
        dispatch(checkError(error));
        dispatch(receiveErrorAlert('No data')); // error message
        setTimeout(() => {
            dispatch(closeAlert());
            dispatch({
                type: FETCH_OFFERS_STAT_ERROR
            })
        }, 2000);
    })
};

export const fetchRetailCallsStat = query => dispatch => {
    dispatch({
        type: FETCH_RETAIL_CALLS_STAT_BEGIN
    });
    return getRetailerCallsStat(query).then(res => {
        dispatch({
            type: FETCH_RETAIL_CALLS_STAT_SUCCESS,
            payload: {
                stat: res.data,
            }
        });
        return res
    }, error => {
        dispatch(checkError(error));
        dispatch(receiveErrorAlert('No data')); // error message
        setTimeout(() => {
            dispatch(closeAlert());
            dispatch({
                type: FETCH_RETAIL_CALLS_STAT_ERROR
            })
        }, 2000);
    })
};

export const fetchRedirectsStat = query => dispatch => {
    dispatch({
        type: FETCH_REDIRECTS_STAT_BEGIN
    });
    return getRedirectsStat(query).then(res => {
        dispatch({
            type: FETCH_REDIRECTS_STAT_SUCCESS,
            payload: {
                redirectsStatisticItems: res.data,
            }
        });
        return res
    }, error => {
        dispatch(checkError(error));
        dispatch(receiveErrorAlert('No data')); // error message
        setTimeout(() => {
            dispatch(closeAlert());
            dispatch({
                type: FETCH_REDIRECTS_STAT_ERROR
            })
        }, 2000);
    })
};

export const saveNewOffer = newOffer => dispatch => {
    const data = mapOfferToFormData(newOffer);
    return addOffer(data).then(res => {
        return res;
    }, error => {
        dispatch(checkError(error));
        dispatch(receiveErrorAlert(error));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
    })
};

const mapOfferToFormData = (offer, isIncludeId = false) => {
    const data = new FormData();
    Object.keys(offer).forEach(field => {
        if (offer[field]) {
            if (field !== 'id' || isIncludeId)
                data.append(field, offer[field]);
        }
    });
    return data;
}

export const updateSingleOffer = offer => dispatch => {
    const data = mapOfferToFormData(offer, true);
    return updateOffer(offer.id, data)
        .then(res => {
            return res;
        }, error => {
            dispatch(checkError(error));
            dispatch(receiveErrorAlert(error));
            setTimeout(() => {
                dispatch(closeAlert());
            }, 2000);
        })
};

export const deleteSingleOffer = id => dispatch => {
    return deleteOffer(id)
        .then(res => {
            return res;
        }, error => {
            dispatch(checkError(error));
            dispatch(receiveErrorAlert(error));
            setTimeout(() => {
                dispatch(closeAlert());
            }, 2000);
        })
};

export const fetchOffers = query => dispatch => {
    dispatch({
        type: FETCH_OFFERS_BEGIN
    });
    return getOffers(query).then(res => {
        dispatch({
            type: FETCH_OFFERS_SUCCESS,
            payload: {
                offers: res.data,
                numberOfElements : res.numberOfElements,
                totalElements: res.totalElements,
                totalPages: res.totalPages
            }
        });
        return res
    }, error => {
        dispatch(checkError(error));
        dispatch(receiveErrorAlert('No data')); // error message
        setTimeout(() => {
            dispatch(closeAlert());
            dispatch({
                type: FETCH_OFFERS_ERROR
            })
        }, 2000);
    })
};

export const fetchOffer = id => dispatch => {
    dispatch({
        type: FETCH_OFFER_BEGIN
    });
    return getOffer(id).then(res => {
        dispatch({
            type: FETCH_OFFER_SUCCESS,
            payload: {
                offer: res.data
            }
        });
        return res
    }, error => {
        dispatch(checkError(error));
        dispatch(receiveErrorAlert('No data')); // error message
        setTimeout(() => {
            dispatch(closeAlert());
            dispatch({
                type: FETCH_OFFER_ERROR
            })
        }, 2000);
    })
};



// WEBPACK FOOTER //
// ./src/actions/promoActions.js